<template>
  <div v-if="activities && activities.length > 0">
    <div class="overflow-auto">
      <div class="overflow-auto" style="max-height: 250px; min-height : 200px">
        <table class="table-auto min-w-max text-sm border border-gray-400 rounded-lg overflow-auto">
          <thead class="bg-gray-100">
            <tr>
              <th
                v-for="(col, i) in columns"
                :key="i"
                class="border border-gray-400 px-3 py-2 font-semibold text-gray-700"
                :style="{ minWidth: col.width || '130px' }"
              >
                {{ col.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(activity, i) in activities"
              :key="i"
              class="hover:bg-gray-50"
            >
              <td
                v-for="(col, j) in columns"
                :key="j"
                class="border border-gray-400 px-3 py-2 text-left"
                :style="{ minWidth: col.width || '100px' }"
              >
                <span v-if="col.key === 'timestamp'">
                  <span
                    v-if="activity.timestamp"
                    :title="activity[col.key] || 'N/A'"
                  >
                    {{ formatTimestamp(activity.timestamp) }}
                  </span>
                  <span v-else>N/A</span>
                </span>
                <span
                  v-else-if="col.truncate"
                  :title="activity[col.key] || 'N/A'"
                >
                  {{ truncateText(activity[col.key] || "N/A", col.length) }}
                </span>

                <span v-else-if="col.key === 'map'">
                  <span
                    v-if="activity.map"
                    class="text-blue-500 underline cursor-pointer"
                    @click="handleMap(activity)"
                  >
                    <u>View</u>
                  </span>
                  <span v-else>N/A</span>
                </span>

                <span v-else-if="col.key === 'browserName'">
                  {{ getBrowserName(activity.browserName) }}
                </span>
                <span v-else-if="col.key === 'reason'">
                  {{ activity.reason || "N/A" }}
                </span>

                <span v-else class="relative">
                  <template v-if="activity[col.key] && typeof activity[col.key] === 'object' && !Array.isArray(activity[col.key])">
                  <span class="text-blue-500 mr-2">Multiple</span>
                    <span
                      class="detail-tooltip-wrapper inline-block"
                      @mouseover="showDetails(activity.id || i, col.key)"
                      @mouseleave="hideDetails(activity.id || i, col.key)"
                    >
                      <i class="fa fa-info-circle text-info pointer info-icon"></i>
                      <div
                        v-if="visibleDetails[getDetailKey(activity.id || i, col.key)]"
                        class="detail-tooltip-box absolute left-0 bottom-full mb-2 bg-gray-800 text-white text-xs rounded py-2 px-3 z-10 whitespace-nowrap"
                      >
                        <div class="details-title font-semibold mb-1">Changes</div>
                        <ul class="details-list list-disc list-inside">
                          <li
                            v-for="(value, key) in activity[col.key]"
                            :key="key"
                            class="detail-item"
                          >
                            <strong>{{ key }}:</strong> {{ value || 'N/A' }}
                          </li>
                        </ul>
                      </div>
                    </span>
                  </template>

                  <span
                    v-else
                    :title="activity[col.key] || 'N/A'"
                  >
                    {{ activity[col.key] || "N/A" }}
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div v-else>
    <p>No activity history found.</p>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "HistoryActivityTable",
  props: {
    activities: {
      type: Array,
      required: true,
      default: () => [],
    },
    columns: {
      type: Array,
      required: true,
      default: () => [
        { label: "Activity On", key: "activityOnUserName", width: "200px" },
        { label: "Activity By", key: "activityByUserName", width: "200px" },
        { label: "Action", key: "action" },
        { label: "Updated In", key: "updatedTimeIn" },
        { label: "Updated Out", key: "updatedTimeOut" },
        { label: "Reason", key: "reason" },
        { label: "Timestamp", key: "timestamp", width: "200px", truncate: true, length: 20 },
        { label: "OS", key: "osName" },
        { label: "Browser", key: "browserName" },
        { label: "Map", key: "map", width: "70px" },
      ],
    },
  },
  data() {
    return {
      visibleDetails: {},
    };
  },
  methods: {
    formatTimestamp(ts) {
      return moment(ts, "DD/MM/YYYY, h:mm:ss a", true).isValid()
        ? moment(ts, "DD/MM/YYYY, h:mm:ss a").format("MMMM D, YYYY h:mm:ss A")
        : "Invalid Date";
    },
    truncateText(text, length) {
      return text && text.length > length
        ? text.substring(0, length) + "..."
        : text;
    },
    getBrowserName(ua) {
      if (!ua) return "N/A";
      ua = ua.toLowerCase();
      if (ua.includes("chrome") && !ua.includes("edg")) return "Chrome";
      if (ua.includes("firefox")) return "Firefox";
      if (ua.includes("safari") && !ua.includes("chrome")) return "Safari";
      if (ua.includes("edg")) return "Edge";
      if (ua.includes("opr") || ua.includes("opera")) return "Opera";
      return "Other";
    },
    handleMap(mapUrl) {
      this.$emit("open-map", mapUrl);
    },
    getDetailKey(activityId, colKey) {
      return `${activityId}-${colKey}`;
    },
    showDetails(activityId, colKey) {
      const key = this.getDetailKey(activityId, colKey);
      this.$set(this.visibleDetails, key, true);
    },
    hideDetails(activityId, colKey) {
      const key = this.getDetailKey(activityId, colKey);
      this.$set(this.visibleDetails, key, false);
    },
  },
};
</script>

<style scoped>
.detail-tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.detail-tooltip-box {
  min-width: 200px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.info-icon {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/HistoryActivityTable.vue